/**
 * Smart SNAP Formatting Utilities
 * 
 * Zeigt Dezimalstellen nur wenn nötig:
 * - 1.0 → "1 SNAP"
 * - 0.5 → "0.5 SNAPs"  
 * - 2.7 → "2.7 SNAPs"
 */

/**
 * Formatiert SNAP-Wert mit intelligenter Dezimalanzeige
 * @param {number|string} snaps - SNAP-Wert
 * @returns {string} Formatierter Wert (z.B. "1", "0.5", "2.7")
 */
export const formatSnaps = (snaps) => {
  const num = parseFloat(snaps);
  
  if (isNaN(num)) {
    return '0';
  }
  
  // Ganzzahl? Keine Dezimalstellen
  if (num % 1 === 0) {
    return num.toString();
  }
  
  // Dezimalzahl: Max 2 Nachkommastellen, trailing zeros entfernen
  const rounded = num.toFixed(2);
  // Entferne trailing zeros: 1.50 → 1.5, 1.00 → 1
  return parseFloat(rounded).toString();
};

/**
 * Formatiert SNAP-Wert mit Pluralisierung
 * @param {number|string} snaps - SNAP-Wert
 * @returns {string} Formatierter Text (z.B. "1 SNAP", "0.5 SNAPs", "2.7 SNAPs")
 */
export const snapText = (snaps) => {
  const formatted = formatSnaps(snaps);
  const num = parseFloat(formatted);
  
  return num === 1 ? `${formatted} SNAP` : `${formatted} SNAPs`;
};

/**
 * Prüft ob SNAP-Wert als Ganzzahl angezeigt werden soll
 * @param {number|string} snaps - SNAP-Wert
 * @returns {boolean} True wenn Ganzzahl
 */
export const isWholeNumber = (snaps) => {
  const num = parseFloat(snaps);
  return !isNaN(num) && num % 1 === 0;
};

/**
 * Berechnet Gesamtkosten in SNAPs
 * @param {number} numImages - Anzahl Bilder
 * @param {number} snapsPerImage - SNAPs pro Bild
 * @returns {number} Gesamtkosten (gerundet auf 1 Dezimalstelle)
 */
export const calculateTotalSnaps = (numImages, snapsPerImage) => {
  const total = numImages * snapsPerImage;
  return parseFloat(total.toFixed(1));
};
